import script from "./FavoriteStar.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteStar.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteStar.vue?vue&type=style&index=0&id=2b415924&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b415924"]])

export default __exports__